<ngx-ui-loader loaderId="isLoader"></ngx-ui-loader>
<div class="row">
    <div class="col-12 px-3 px-md-5">
        <div *ngIf="!isProgramDocument?.length" class="alert alert-primary text-center" role="alert">
            No documents uploaded
        </div>

        <div class="documents-list">
            <div class="document-item d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3 border-bottom bg-white mb-2 rounded shadow-sm"
                *ngFor="let document of isProgramDocument"  [ngClass]="{ ' border border-invalid-pitch border-invalid border-invalid-padding ': validationCheckClicked && document.isMandatory &&  isSubmissionEmpty(document.submission)}">
                <div class="d-flex align-items-start w-100 flex-row flex-wrap gap-3 mr-3">

                    <div class="position-relative" style="padding: 16px 6px">
                        <div class="fi fi-{{ document.extension || 'any' }} m-0" style="z-index: 0;">
                            <i ngbTooltip="File uploaded"
                                class="bi bi-check-circle-fill text-success bg-white rounded fs-2 position-absolute"
                                style="z-index: 1000; top: -5px; left: -5px;"
                                *ngIf="document?.url?.objectUrl"></i>
                            <div class="fi-content">{{ document.extension || 'any' }}</div>
                        </div>
                    </div>

                    <div class="ms-4 flex-grow-1" style="text-align: left; padding: 20px;">
                         <p class="mb-0 fw-bold text-truncate">
                            {{ document.name }} <span class="text-danger" *ngIf="document.isMandatory">*</span> <span class="mb-1 fw-bold text-truncate small text-primary" *ngIf="document.submission?.fileName">({{ document.submission.fileName }})</span>
                        </p>
                         <p class="mb-0 small" style="word-break: break-word; color: #333; font-style: italic;">
                            {{ document.description | titlecase }}
                        </p>
                        <div class="form-text"> Allowed file types: {{document.allowedFileTypes? document.allowedFileTypes :document.fileType === 'image'? 'png,jpg,jpeg,webp': 'pdf,doc,docx,xls,xlsx,ppt,pptx,zip'}} and max size of {{document.size }}mb. </div>
                         <p *ngIf="document.submission &&  document.submission?.approvalStatus=='rejected'" class="mb-0 text-danger small p-2 border rounded mt-2" style="white-space: pre-wrap; word-break: break-word;">
                            {{ document.submission.rejectedReason | titlecase }}
                        </p>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-3 mt-md-0 gap-2">
                    <input type="file" #fileInput hidden (change)="supportingFileBrowseHandler($event, document)"
                        [attr.accept]="getAcceptTypes(document,document.fileType)" />
                    
                    <button  *ngIf="document.url" (click)="downloadFile(document.url.objectUrl, document.submission?.fileName )" ngbTooltip="Download Document"
                        class="btn btn-secondary text-black py-2 px-3 my-2 ls-2 text-uppercase fw-boldest btn-sm me-2">
                        <i class="fa fa-download ms-1"></i>
                    </button>
                    <button *ngIf="!document.url" class="btn btn-dark btn-sm  py-2 px-3 my-2 ls-2 text-uppercase fw-boldest btn-sm me-2" (click)="fileInput.click()"
                        ngbTooltip="Upload Document">
                        <i class="fa fa-upload ms-1"></i>
                    </button>

                    <button *ngIf="document.url && document.submission?.approvalStatus=='rejected'" class="btn btn-dark btn-sm text-white py-2 px-3 my-2 ls-2 text-uppercase fw-boldest btn-sm me-2" (click)="fileInput.click()"
                        ngbTooltip="Re-Upload Document">
                        <i class="fa fa-edit ms-1"></i>
                    </button>
                    <button *ngIf="document.url && !hasRejectedFile()" class="btn btn-danger btn-sm py-2 px-3 my-2 ls-2 text-uppercase fw-boldest btn-sm me-2"  (click)="handleDelete(document)"
                        ngbTooltip="Delete Document">
                        <i class="fa fa-trash ms-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>